module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_3009.34850230.png";